import { render, staticRenderFns } from "./HotkeyModal.vue?vue&type=template&id=42b26340&scoped=true"
import script from "./HotkeyModal.vue?vue&type=script&lang=ts"
export * from "./HotkeyModal.vue?vue&type=script&lang=ts"
import style0 from "./HotkeyModal.vue?vue&type=style&index=0&id=42b26340&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b26340",
  null
  
)

export default component.exports